/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OfferCreateContentCompetencesInner } from './OfferCreateContentCompetencesInner';
import {
    OfferCreateContentCompetencesInnerFromJSON,
    OfferCreateContentCompetencesInnerFromJSONTyped,
    OfferCreateContentCompetencesInnerToJSON,
} from './OfferCreateContentCompetencesInner';
import type { OfferCreateDiscountsInner } from './OfferCreateDiscountsInner';
import {
    OfferCreateDiscountsInnerFromJSON,
    OfferCreateDiscountsInnerFromJSONTyped,
    OfferCreateDiscountsInnerToJSON,
} from './OfferCreateDiscountsInner';
import type { OfferCreateForCompanySpace } from './OfferCreateForCompanySpace';
import {
    OfferCreateForCompanySpaceFromJSON,
    OfferCreateForCompanySpaceFromJSONTyped,
    OfferCreateForCompanySpaceToJSON,
} from './OfferCreateForCompanySpace';

/**
 * 
 * @export
 * @interface OfferCreate
 */
export interface OfferCreate {
    /**
     * 
     * @type {number}
     * @memberof OfferCreate
     */
    content_id: number;
    /**
     * 
     * @type {string}
     * @memberof OfferCreate
     */
    note: string;
    /**
     * 
     * @type {number}
     * @memberof OfferCreate
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof OfferCreate
     */
    is_public?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfferCreate
     */
    is_active?: boolean;
    /**
     * 
     * @type {Array<OfferCreateDiscountsInner>}
     * @memberof OfferCreate
     */
    discounts?: Array<OfferCreateDiscountsInner>;
    /**
     * 
     * @type {string}
     * @memberof OfferCreate
     */
    descriptions?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferCreate
     */
    category_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof OfferCreate
     */
    promo_video_url?: string;
    /**
     * 
     * @type {OfferCreateForCompanySpace}
     * @memberof OfferCreate
     */
    for_company_space?: OfferCreateForCompanySpace;
    /**
     * 
     * @type {Array<OfferCreateContentCompetencesInner>}
     * @memberof OfferCreate
     */
    content_competences?: Array<OfferCreateContentCompetencesInner>;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferCreate
     */
    learning_event_ids?: Array<number>;
}

/**
 * Check if a given object implements the OfferCreate interface.
 */
export function instanceOfOfferCreate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "content_id" in value;
    isInstance = isInstance && "note" in value;
    isInstance = isInstance && "price" in value;

    return isInstance;
}

export function OfferCreateFromJSON(json: any): OfferCreate {
    return OfferCreateFromJSONTyped(json, false);
}

export function OfferCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content_id': json['content_id'],
        'note': json['note'],
        'price': json['price'],
        'is_public': !exists(json, 'is_public') ? undefined : json['is_public'],
        'is_active': !exists(json, 'is_active') ? undefined : json['is_active'],
        'discounts': !exists(json, 'discounts') ? undefined : ((json['discounts'] as Array<any>).map(OfferCreateDiscountsInnerFromJSON)),
        'descriptions': !exists(json, 'descriptions') ? undefined : json['descriptions'],
        'category_ids': !exists(json, 'category_ids') ? undefined : json['category_ids'],
        'promo_video_url': !exists(json, 'promo_video_url') ? undefined : json['promo_video_url'],
        'for_company_space': !exists(json, 'for_company_space') ? undefined : OfferCreateForCompanySpaceFromJSON(json['for_company_space']),
        'content_competences': !exists(json, 'content_competences') ? undefined : ((json['content_competences'] as Array<any>).map(OfferCreateContentCompetencesInnerFromJSON)),
        'learning_event_ids': !exists(json, 'learning_event_ids') ? undefined : json['learning_event_ids'],
    };
}

export function OfferCreateToJSON(value?: OfferCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content_id': value.content_id,
        'note': value.note,
        'price': value.price,
        'is_public': value.is_public,
        'is_active': value.is_active,
        'discounts': value.discounts === undefined ? undefined : ((value.discounts as Array<any>).map(OfferCreateDiscountsInnerToJSON)),
        'descriptions': value.descriptions,
        'category_ids': value.category_ids,
        'promo_video_url': value.promo_video_url,
        'for_company_space': OfferCreateForCompanySpaceToJSON(value.for_company_space),
        'content_competences': value.content_competences === undefined ? undefined : ((value.content_competences as Array<any>).map(OfferCreateContentCompetencesInnerToJSON)),
        'learning_event_ids': value.learning_event_ids,
    };
}

